import React, { useEffect } from "react";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import FormTextField from "../../components/formFields/FormTextField";
import { MdDelete } from "react-icons/md";
import IconButton from "../../components/common/IconButton";

import { setAgentContactDeleteIndex } from "./agentSlice";
import {
  emailWOValueValidator,
  MobileNoWOValueValidator,
} from "../../components/formFields/CommonValidator";

const ContactArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const contactDeleteIndex = useAppSelector((state) => state.agent.deleteIndex);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const dispatch = useAppDispatch();

  const name = fieldArrayRenderProps.name || "";

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("agentContactDeleteDialog"));
    dispatch(setAgentContactDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setAgentContactDeleteIndex(1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        Name: "",
        MobileNo: "",
        EmailID: "",
        Designation: "",
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {fieldArrayRenderProps.value && fieldArrayRenderProps.value.length === 0
        ? pushElementInarray()
        : null}
      <GridLayoutItem style={{ marginBottom: 10 }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Contact
        </Button>
      </GridLayoutItem>
      {dialogName === "agentContactDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Contact"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(contactDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((contact: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card">
              <GridLayout
                style={{ marginRight: 40 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "24%" },
                  { width: "24%" },
                  { width: "24%" },
                  { width: "24%" },
                  { width: "4%" },
                ]}
              >
                <GridLayoutItem>
                  <Field
                    // name={`AgentContact.${index}.Name`}
                    name={`${name}.${index}.Name`}
                    label="Name"
                    placeholder="i.e John"
                    component={FormTextField}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    // name={`AgentContact.${index}.MobileNo`}
                    label="Mobile No"
                    name={`${name}.${index}.MobileNo`}
                    placeholder="i.e. 9999999999"
                    type="number"
                    max="10"
                    component={FormTextField}
                    validator={MobileNoWOValueValidator}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    // name={`AgentContact.${index}.EmailID`}
                    name={`${name}.${index}.EmailID`}
                    label="Email ID"
                    placeholder="i.e. example@example.com"
                    component={FormTextField}
                    validator={emailWOValueValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    // name={`AgentContact.${index}.Designation`}
                    name={`${name}.${index}.Designation`}
                    label="Designation"
                    placeholder="Designation"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    name={`HotelContacts.${index}.IsOwner`}
                    label="Is Owner"
                    placeholder="Is Owner"
                    component={FormSelectionField}
                    options={BOOLEAN?.map((owner: any) => {
                      return {
                        value: owner?.value,
                        label: owner?.label,
                      };
                    })}
                  />
                </GridLayoutItem> */}
                <GridLayoutItem
                  style={{
                    textAlign: "right",
                    position: "relative",
                  }}
                >
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    // disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{
                      position: "absolute",
                      top: 35,
                      right: 0,
                      height: 30,
                      width: 30,
                    }}
                    icon={MdDelete}
                    iconClassName="absolute-position"
                    iconStyle={{ fontSize: "20px" }}
                  />
                </GridLayoutItem>
              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}
    </GridLayout>
  );
};

export default ContactArray;
